import Axios from 'axios'
import {getCookie, graphQLURL, graphQLToken} from '../../utils/common';

export const fetchTrades = () => {
    const apiUrl = getCookie('apiUrl') || 'https://api.optionsedu.com/graphql'
    const query = {
        query: `{
      portfolio {
        portfolioSnapshot {
          tradeID
          name
          openDate
          closedDate
          strategy
          symbols      
          openProfit
          closedProfit
          profit
          transactions {
            tradeDate
            quantity
            symbol
            underlying
            assetType        
            expiration
            strike
            price
            transactionGroup  
            quantity
            assetType
            action
            mark
          }
        }
      }
    }`
    }

    const CONTENT_TYPE = { 'Content-Type': 'application/json' }
    return Axios.post(apiUrl, query, CONTENT_TYPE).catch(e=> {
        return null;
    })
}

export const fetchTradePost = (id) => {
    const apiUrl = getCookie('graphQLURL') || graphQLURL
    const token = getCookie('securityToken') || graphQLToken
    const query = {
        query: `
          query {
            trades(where:{tradeIdentifier: "${id}"}) {
                tradeIdentifier
                posts {
                    id 
                    title
                    content
                    shortcontent
                    postDate
                    slug
            }
          }
        }`
    }

    const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    return Axios.post(apiUrl, query, CONTENT_TYPE)
}


// WEBPACK FOOTER //
// ./src/actions/trades/index.js